<template>
	<modal name="loadModal">
		<div>
			<b-row>
				<b-col
					class="d-flex align-items-center justify-content-center"
				>
					<b-icon
						icon="arrow-clockwise"
						animation="spin"
						font-scale="4"
					></b-icon>
				</b-col>
			</b-row>
		</div>
	</modal>
</template>

<script>
	import Modal from "./Modal"

	export default {
		name: "LoadModal",
		components: { Modal }
	}
</script>

<style lang="scss">
@import "../assets/scss/global";

	.b-icon.b-icon-animation-spin {
		path {
			fill: $cor1;
		}
	}
</style>